import { components } from "api/schema/api-schema";
import { WorkflowDiagramReactFlow } from "components/WorkflowEditor/WorkflowDiagram/WorkflowDiagramReactFlow";
import { colorsByRunStatus } from "types/ColorsByRunStatus";

export interface TabStatusGraphProps {
  progress: components["schemas"]["RunProgress"];
}

export const TabStatusGraph = ({ progress }: TabStatusGraphProps) => {
  return (
    <WorkflowDiagramReactFlow
      graphNodes={progress.nodes.map((n) => ({
        id: n.id,
        data: {
          label: n.label,
          color:
            n.status !== undefined ? colorsByRunStatus[n.status] : "lightGray",
        },
      }))}
      graphEdges={progress.edges.map((e) => ({
        id: e.source_id + e.target_id,
        source: e.source_id,
        target: e.target_id,
      }))}
      graphInputs={[]}
      graphResults={[]}
    />
  );
};
